import React, { useEffect, useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { useTheme } from '@emotion/react'
import UseMAcRequest from './UseMAcRequest'
import MacAuthentication from './MacAuthentication'
import MacManagement from './MacManagement'
import { useSearchParams } from 'react-router-dom'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { macDetailTabIds } from '../../GeneralSettings/GSConstants'
import WebCargoMACMgt from './WebCargoMACMgt'
import { useTranslation } from '../../../../i18n/I18nProvider'

const USER_MAC_REQUEST_JOB_ID = 28
const MAC_AUTHENTICATION_JOB_ID = 29
const MAC_MANAGEMENT_JOB_ID = 30
const URL_GATED_MAC_JOB_IDS = [USER_MAC_REQUEST_JOB_ID, MAC_AUTHENTICATION_JOB_ID, MAC_MANAGEMENT_JOB_ID]

const isRoleRightJobActive = (rightsList = [], jobId) => {
  if (!Array.isArray(rightsList) || !rightsList.length) return false
  const job = rightsList.find((item) => Number(item?.JobID ?? item?.Jobid) === Number(jobId))
  if (!job) return false
  return Number(job.IsActive ?? job.isActive) === 1
}

const MacDetailes = ({ loginData, FromUrlRedirect = false }) => {
  const { translations } = useTranslation()
  const bum = translations?.branchAndUserMaster || {}
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || '')
  const [allTabs, setAllTabs] = useState([])
  const macTabNames = [
    { name: bum.userMacRequest || 'User Mac Request', JobID: USER_MAC_REQUEST_JOB_ID },
    { name: bum.macAuthenticationUpper || 'MAC AUTHENTICATION', JobID: MAC_AUTHENTICATION_JOB_ID },
    { name: bum.macManagementUpper || 'MAC MANAGEMENT', JobID: MAC_MANAGEMENT_JOB_ID },
    { name: bum.webCargoMacMgt || 'Web Cargo MAC Mgt', JobID: 31 },
  ]
  const isMacTabVisible = (jobId, rightsList = allTabs) => {
    if (FromUrlRedirect && URL_GATED_MAC_JOB_IDS.includes(Number(jobId))) {
      return isRoleRightJobActive(rightsList, jobId)
    }
    return findObjctByValueFromArrayOfObject(rightsList, jobId, 'JobID', 'IsActive') === 1
  }

  const theme = useTheme()
  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);

    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    } else {
      setAllTabs([])
    }

    const rightsList = allGSPagesActive || []
    const visibleMacTabs = macTabNames.filter((item) => isMacTabVisible(item.JobID, rightsList))
    if (selectedTab === '' || (FromUrlRedirect && !visibleMacTabs.some((item) => Number(item.JobID) === Number(selectedTab)))) {
      goToTabs(visibleMacTabs?.[0]?.JobID)
    }
  }, [searchParams, selectedTab, FromUrlRedirect]);
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }

  // const handleMacTabs = (event, value) => {
  //     setMacTabs(value)
  //     // setTableHeader(tableHeaders[value])
  // }
  const getMacDetailesTab = (typeId, label) => {
    switch (typeId) {
      case USER_MAC_REQUEST_JOB_ID:
        return isMacTabVisible(USER_MAC_REQUEST_JOB_ID) ? <UseMAcRequest loginData={loginData} /> : ''
      case MAC_AUTHENTICATION_JOB_ID:
        return isMacTabVisible(MAC_AUTHENTICATION_JOB_ID) ? <MacAuthentication loginData={loginData} /> : ''
      case MAC_MANAGEMENT_JOB_ID:
        return isMacTabVisible(MAC_MANAGEMENT_JOB_ID) ? <MacManagement loginData={loginData} /> : ''
      case 31:
        return <WebCargoMACMgt loginData={loginData} />
      default:
        return label
    }
  }
  return (
    <>
      <Box className="bookingPageTabContainer">
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              variant="scrollable"
              value={selectedTab}
              onChange={(e, newValue) => goToTabs(newValue)}
              aria-label="bsic tabs example"
              sx={{
                minHeight: 'unset',
                alignItems: 'center',
                '& .MuiTabs-scrollButtons.Mui-disabled': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: 'grey !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
                '& .Mui-disabled': {
                  backgroundColor: 'transparent !important',
                  border: 'none !important',
                  color: 'red',
                },
                '& .MuiTabs-scrollButtons': {
                  opacity: 1,
                  width: '25px',
                  height: '25px',
                  borderRadius: '50px',
                  background: '#0086ff !important',
                  fontSize: '20px',
                  color: 'white !important',
                  marginTop: '0px',
                },
              }}
            >
              {macTabNames.map((reqType, index) => (
                <Tab key={`sender_${reqType.JobID}`} value={reqType.JobID} label={reqType.name} {...macDetailTabIds(reqType.JobID)}
                  sx={{
                    display: isMacTabVisible(reqType.JobID) ? 'block' : 'none',
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {macTabNames.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
              style={{
                display: isMacTabVisible(reqType.JobID) ? 'block' : 'none',
              }}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getMacDetailesTab(reqType.JobID, reqType.name)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}
export default MacDetailes